var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallBankDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.456 25.48H2.885a1.19 1.19 0 0 0-1.183 1.182 1.19 1.19 0 0 0 1.183 1.182h23.57a1.19 1.19 0 0 0 1.183-1.182 1.19 1.19 0 0 0-1.182-1.183zM4.359 22.417A1.19 1.19 0 0 0 3.176 23.6a1.19 1.19 0 0 0 1.183 1.182h20.623a1.19 1.19 0 0 0 1.182-1.182 1.19 1.19 0 0 0-1.182-1.183h-.292v-10.61h.292a.58.58 0 0 0 .583-.584.58.58 0 0 0-.583-.583H4.359a.58.58 0 0 0-.583.583c0 .324.259.583.583.583h.292v10.611h-.292zm17.966-10.61v10.61h-3.532v-10.61h3.532zm-5.897 0v10.61h-3.532v-10.61h3.532zm-9.428 0h3.531v10.61H7v-10.61zM2.885 9.57h23.587a1.19 1.19 0 0 0 1.183-1.182c0-.518-.34-.956-.794-1.118L15.164 2.005a1.135 1.135 0 0 0-.972 0L2.4 7.303a1.169 1.169 0 0 0-.664 1.328c.113.55.583.94 1.15.94z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallBankDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-bank-default.5059f17c4c0a77170c79c67d8dc0f570.svg";